import { defaultVisitors } from '@genericBookings/types/Visitors';
export default {
    DayTicketId: 217,
    VisitDate: '',
    ...defaultVisitors,
    acceptTerms: false,
    Sessions: [],
};
